module.exports = __webpack_public_path__ + "cce1581032546f3e7735e1284a585458.woff2";